import { useFlag } from '@thesisedu/react'

export function useHeaderTagVisibility() {
  return useFlag<boolean>('assignments:header-tag-visibility', true)
}
